import {Component, OnInit, ChangeDetectionStrategy, Input} from '@angular/core';
import {StandardFormMetaInfo} from '../standard-form-builder/standard-form-meta-info.model';

@Component({
  selector: 'app-attributes-list',
  templateUrl: './attributes-list.component.html',
  styleUrls: ['./attributes-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttributesListComponent implements OnInit {
  @Input() meta: StandardFormMetaInfo[];
  @Input() values: any;
  constructor() { }

  ngOnInit() {
    return;
  }
  getValue(values, info) {
    let result = '';
    try {
      result = info.value(values);
    } catch (e) {
      result = '';
    }

    return result;
  }
}
